import React from "react";
import styled from "styled-components";
import Container from "storybook-components/Container";
import { FlexContainer } from "storybook-components/Container";
import { SubheadLg, SubheadSm, Caption, BodyStyle } from "storybook-components/Typography";
import QuoteMarks from "./images/stylized-quote-marks.svg";

const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.green4};
  padding: 48px 16;
  ${props => props.theme.media.desktopUp`
    padding: 120px 0;
  `};
`;

const StyledContainer = styled(Container)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  ${({ theme }) => theme.media.desktopUp`
    flex-direction: row;
    justify-content: space-between;
  `}
`;

const QuoteColumn = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 2rem 0;
  ${({ theme }) => theme.media.desktopUp`
    padding: 0;
    width: 75%;
    margin: 0 2.5%;
  `}
`;

const QuoteBackgroundWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.green2};
  border-radius: 20px;
  padding: 16px;
  border-top-right-radius: 0;
  ${({ theme }) => theme.media.desktopUp`
    border-top-right-radius: 20px;
    border-bottom-right-radius: 0;
    padding: 32px 48px;
  `}
`;

const QuoteText = styled(SubheadLg)`
  color: ${({ theme }) => theme.colors.green5};
  ${({ theme }) => theme.media.desktopUp`
    margin: 0;
  `};
`;

const QuoteMarkMobileRow = styled(FlexContainer)`
  margin-top: 64px;
  display: flex;
  ${({ theme }) => theme.media.desktopUp`
    display: none;
  `}
`;

const QuoteMarkDesktopRow = styled(FlexContainer)`
  display: none;
  ${({ theme }) => theme.media.desktopUp`
    display: flex;
    margin-bottom: 100px;
  `}
`;

const QuoteMarkWrapper = styled.div`
  display: block;
  position: relative;
  width: 30%;
  ${({ theme }) => theme.media.desktopUp`
    width: 40%;
  `}
`;

const QuoteMarkImg = styled.img`
  width: 100%;
  position: absolute;
  bottom: 20px;
  ${({ theme }) => theme.media.desktopUp`
    padding-right: 20px;
    bottom: unset;
    padding-top: 40px;
  `}
`;

const QuoteBylineWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.green2};
  align-self: flex-end;
  width: calc(70% - 20px);
  height: 64px;
  border-top-right-radius: 20px;
  border-top-left-radius: 20px;
  display: flex;
  justify-content: space-between;
  ${({ theme }) => theme.media.desktopUp`
    height: auto;
    width: calc(60% - 20px);
    border-radius: 0;
    border-bottom-right-radius: 20px;
    border-bottom-left-radius: 20px;
    padding: 32px 48px;
  `}
`;

const AuthorName = styled(SubheadSm)`
  ${BodyStyle};
  color: ${({ theme }) => theme.colors.green1};
  font-weight: 500;
  margin: 6px 0 0;
  ${({ theme }) => theme.media.desktopUp`
    margin: 0;
    color: ${({ theme }) => theme.colors.green5};
  `};
`;

const AuthorTitle = styled(Caption)`
  ${BodyStyle};
  margin: 0;
  color: ${({ theme }) => theme.colors.green1};
  ${({ theme }) => theme.media.desktopUp`
    color: ${({ theme }) => theme.colors.green5};
  `};
`;

const QuoteBylineSlashWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.green2};
  width: 20px;
  height: 64px;
  ${({ theme }) => theme.media.desktopUp`
    height: 100%;
  `}
`;

const QuoteBylineSlash = styled.div`
  width: 20px;
  height: 100%;
  background-color: ${({ theme }) => theme.colors.green4};
  border-bottom-right-radius: 20px;
  ${({ theme }) => theme.media.desktopUp`
    border-bottom-right-radius: 0;
    border-top-right-radius: 20px;
  `}
`;

const HeadshotWrapper = styled.div`
  width: 100%;
  display: flex;
  padding-bottom: 40px;
  ${({ theme }) => theme.media.desktopUp`
    padding-bottom: 0;
    display: block;
    width: 20%;
  `};
`;

const HeadshotImg = styled.img`
  max-width: 100%;
  width: 40%;
  ${({ theme }) => theme.media.desktopUp`
    width: 100%;
  `};
`;

const MobileBylineWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: ${({ theme }) => theme.colors.green5};
  border-radius: 6px;
  margin-left: 12px;
  padding: 12px 12px 16px;
  ${({ theme }) => theme.media.desktopUp`
    display: none;
  `};
`;

export default ({
  quoteBody,
  quoteAuthor,
  quoteAuthorTitle,
  greenLogo,
  whiteLogo,
  quoteAuthorHeadshot
}) => {
  return (
    <Wrapper>
      <StyledContainer>
        <QuoteColumn>
          <QuoteMarkMobileRow>
            <QuoteMarkWrapper>
              <QuoteMarkImg src={QuoteMarks} />
            </QuoteMarkWrapper>
            <QuoteBylineSlashWrapper>
              <QuoteBylineSlash />
            </QuoteBylineSlashWrapper>
            <QuoteBylineWrapper />
          </QuoteMarkMobileRow>
          <QuoteBackgroundWrapper>
            {/* <img src={QuoteWrapperDesktop}/> */}
            <QuoteText>{quoteBody}</QuoteText>
          </QuoteBackgroundWrapper>
          <QuoteMarkDesktopRow>
            <QuoteMarkWrapper>
              <QuoteMarkImg src={QuoteMarks} />
            </QuoteMarkWrapper>
            <QuoteBylineSlashWrapper>
              <QuoteBylineSlash />
            </QuoteBylineSlashWrapper>
            <QuoteBylineWrapper>
              <div>
                <AuthorName>{quoteAuthor}</AuthorName>
                <AuthorTitle>{quoteAuthorTitle}</AuthorTitle>
              </div>
              <img src={greenLogo} />
            </QuoteBylineWrapper>
          </QuoteMarkDesktopRow>
        </QuoteColumn>
          <HeadshotWrapper>
            <HeadshotImg src={quoteAuthorHeadshot} />
            <MobileBylineWrapper>
              <div>
                <AuthorName>{quoteAuthor}</AuthorName>
                <AuthorTitle>{quoteAuthorTitle}</AuthorTitle>
              </div>
              <HeadshotImg src={whiteLogo} />
            </MobileBylineWrapper>
          </HeadshotWrapper>
      </StyledContainer>
    </Wrapper>
  );
};
